// libraries
import React, {useEffect} from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {useSelector} from 'react-redux';
// import BiometricScreen from '../screens/TabScreen/BiometricScreen';
import MainTab from './MainTab';
import {RootState} from '../store';
import LoginScreen from '../screens/AuthScreen/LoginScreen';
import RecoverScreen from '../screens/AuthScreen/RecoverScreen';
import RegisterScreen from '../screens/AuthScreen/RegisterScreen';
import MainTabVisitor from './MainTabVisitor';

// screens

// constants
const MainStack = createNativeStackNavigator();
const optionsDefault = {
  headerShown: false,
};

function AuthRoute() {
  return (
    <>
      <MainStack.Screen
        component={MainTabVisitor}
        name="MainTabVisitor"
        options={optionsDefault}
      />
      <MainStack.Screen
        component={LoginScreen}
        name="LoginScreen"
        options={optionsDefault}
      />
      <MainStack.Screen
        component={RecoverScreen}
        name="RecoverScreen"
        options={optionsDefault}
      />
      <MainStack.Screen
        component={RegisterScreen}
        name="RegisterScreen"
        options={optionsDefault}
      />
    </>
  );
}

function TabRoute() {
  return (
    <>
      {/* <MainStack.Screen
        component={BiometricScreen}
        name="BiometricScreen"
        options={optionsDefault}
      /> */}
      <MainStack.Screen
        component={MainTab}
        name="MainTab"
        options={optionsDefault}
      />
    </>
  );
}

function Routes() {
  const userInfo = useSelector((state: RootState) => state?.user?.user);
  const biometric = useSelector((state: RootState) => state.config.biometric);

  function initialRoute() {
    if (userInfo?.token) {
      return biometric ? 'BiometricScreen' : 'MainTab';
    }
    return 'MainTabVisitor';
  }

  return (
    <MainStack.Navigator initialRouteName={initialRoute()}>
      {AuthRoute()}
      {TabRoute()}
    </MainStack.Navigator>
  );
}

export default Routes;
